import { forwardRef } from 'react';
import { StyledDrawerExit } from './styled';
import { useDrawerContext } from '../../../contexts/drawer';
import Icon from '../../../components/Icon';

const DrawerExit = forwardRef((props, ref) => {
  const { exitProps } = useDrawerContext();

  return (
    <StyledDrawerExit {...exitProps(ref, props)}>
      <Icon name="exit" />
    </StyledDrawerExit>
  );
});

export default DrawerExit;
